import { getDeviceTimezone } from '@/utils/date';
import { transformToRepViewProspectRowData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/transformers/rep-view-prospects-transformers';
import { useGeneratedSalesPortalRepViewProspectsQuery } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/documents/sales-portal-rep-view-prospects.generated';
import { useMemo } from 'react';
import type { ApolloError } from '@apollo/client';
import type { RepViewProspectRowData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

interface UseRepViewProspectsLoaderParams {
  businessOrganizationUUID: string;
}

interface UseRepViewProspectsLoaderResult {
  error?: ApolloError;
  loading: boolean;
  prospects: RepViewProspectRowData[];
  refetch: () => void;
}

/**
 * Loads every prospect chat owned by the signed-in rep
 *
 * @returns Prospect chat rows owned by the signed-in rep
 */
export function useRepViewProspectsLoader({
  businessOrganizationUUID,
}: UseRepViewProspectsLoaderParams): UseRepViewProspectsLoaderResult {
  const { data, error, loading, refetch } =
    useGeneratedSalesPortalRepViewProspectsQuery({
      variables: {
        businessOrganizationUUID,
        userTimezone: getDeviceTimezone(),
      },
    });

  const prospects = useMemo(
    () =>
      transformToRepViewProspectRowData(
        data?.getSalesPortalProspectListInfo ?? [],
      ),
    [data],
  );

  return { error, loading, prospects, refetch };
}
